<script setup lang="ts">
import TypographyItem from '@/components/Typography/TypographyItem.vue'
import type { DeviceCommandHistoryModel } from '@/types/models/DeviceCommandHistoryModel'
import { DATETIME_FORMAT } from '@/utils/dateUtils'
import moment from 'moment'
import ClickableTypography from '../../../../../components/Typography/ClickableTypography.vue'
import TypographyWithPrefix from '../../../../../components/Typography/TypographyWithPrefix.vue'
import { ADMIN_USERS_ROUTES } from '../../../../../router/routing/adminRouting/adminRoutes'

type Props = { command: DeviceCommandHistoryModel }
const props = defineProps<Props>()
</script>

<template>
    <TypographyWithPrefix :prefix="$t('device.actions.commands.from')">
        <template #edit>
            <ClickableTypography
                v-if="command.editor_id"
                :label="command.editor_name"
                :href="ADMIN_USERS_ROUTES.buildUrl(command.editor_id)" />
            <TypographyItem v-else :label="command.user_name ?? $t('common.unknown')" />
        </template>
    </TypographyWithPrefix>
    <TypographyWithPrefix
        v-if="command.updated_at"
        :prefix="$t('device.actions.commands.lastUpdate')">
        <template #edit>
            <TypographyItem :label="moment(command.updated_at).format(DATETIME_FORMAT)" />
        </template>
    </TypographyWithPrefix>
</template>

<style scoped lang="scss">
.collapse-item {
    & :deep(.collapse-title) {
        width: 100%;
        place-content: space-between;
        box-shadow: 0px 0px 3px 1px $primary;
        padding: 4px;
    }
    & :deep(.collapse-content) {
        padding: 8px;
        border: 1px solid $primary;
    }
    &:deep(.collapse-title) {
        flex-direction: row;
    }

    color: var(--color-text);
}

.command-arguments {
    &.stack {
        flex-direction: row;
        flex-wrap: wrap;
    }
}
</style>
